import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../api";

const AuthCtx = createContext(null);

export function useAuth() {
    return useContext(AuthCtx);
}

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    async function refresh() {
        try {
            const res = await api.me();
            setUser(res.user || null);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        refresh();
    }, []);

    const value = useMemo(() => {
        return {
            user,
            loading,
            isAuthed: !!user,
            role: user ? Number(user.role) : 0,
            mustChange: user ? Number(user.must_change) === 1 : false,
            login: async (username, password) => {
                const res = await api.login(username, password);
                setUser(res.user || null);
                return res.user;
            },
            logout: async () => {
                try {
                    await api.logout();
                } finally {
                    setUser(null);
                }
            },
            refresh
        };
    }, [user, loading]);

    return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}
